import React from 'react';
import { Link, useMediaQuery } from '@material-ui/core';
import { stringify } from 'qs';
import styled from 'styled-components';

const DESKTOP_MAP_WIDTH = 530;
const DESKTOP_MAP_HEIGHT = 240;

const MOBILE_MAP_WIDTH = 340;
const MOBILE_MAP_HEIGHT = 140;

const Map = ({ address, catererName }) => {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const staticMapUrlOptions = {
    center: address,
    markers: address,
    size: mobile
      ? `${MOBILE_MAP_WIDTH}x${MOBILE_MAP_HEIGHT}`
      : `${DESKTOP_MAP_WIDTH}x${DESKTOP_MAP_HEIGHT}`,
    scale: 1,
    key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_TOKEN,
  };

  const externalMapUrlOptions = {
    api: '1',
    query: address,
  };

  const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?${stringify(
    staticMapUrlOptions
  )}`;

  const externalMapUrl = `https://www.google.com/maps/search/${stringify(
    externalMapUrlOptions
  )}`;

  return (
    <StyledContainer>
      <Link href={externalMapUrl} target="_blank" rel="noopener noreferrer">
        <StyledImg src={staticMapUrl} alt={`${catererName} location`} />
      </Link>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledImg = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Map;
